import React from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import {useFormik} from 'formik';
import {createSosPlace, getSosPlaceById, updateSosPlace} from "../../../../services/sosPlaceSvc";
import {lang} from "../../../../types/lang";
import {LANGUAGES} from "../../../../mock/languages";
import {LatLngTuple} from "leaflet";
import {useNotification} from "../../../../context/NotificationContext";
import {useQuery} from "react-query";

interface SosModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  activeTab: lang;
  setActiveTab: (lang: lang) => void;
  clickedLocation: LatLngTuple | null;
  refetchSosPlaces: () => void;
  setClickedLocation: (location: [number, number] | null) => void;
  selectedPlace: any;
}

const SosModal: React.FC<SosModalProps> = ({
                                             showModal,
                                             handleModalClose,
                                             activeTab,
                                             setActiveTab,
                                             clickedLocation,
                                             refetchSosPlaces,
                                             setClickedLocation,
                                             selectedPlace
                                           }) => {

  const {showNotification} = useNotification();
  const {data: sosById} = useQuery(
      ["getSosPlaceById", selectedPlace?.id],
      () => getSosPlaceById(selectedPlace?.id),
      {
        enabled: !!selectedPlace,
      }
  );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: {
        uz: sosById?.name_uz || '',
        ru: sosById?.name_ru || '',
        en: sosById?.name_en || '',
      },
      is_active: sosById?.is_active || false,
    },
    onSubmit: async (values) => {
      const formData = new FormData();

      values?.name.uz && formData.append('name_uz', values.name.uz);
      values?.name.en && formData.append('name_en', values.name.en);
      values?.name.ru && formData.append('name_ru', values.name.ru);
      values?.is_active && formData.append('is_active', values.is_active.toString());
      clickedLocation?.[0].toString() && formData.append('latitude', clickedLocation?.[0].toString() || '');
      clickedLocation?.[1].toString() && formData.append('longitude', clickedLocation?.[1].toString() || '');
      try {
        let res;
        if (selectedPlace) {
          res = await updateSosPlace(selectedPlace.id, formData);
        } else {
          res = await createSosPlace(formData);
        }
        if (res.success) {
          handleModalClose();
          refetchSosPlaces();
          setClickedLocation(null);
        }
      } catch (e) {
        showNotification('Xatolik!', '', 'error');
      }
    },
  });

  return (
      <Modal size={"lg"} show={showModal} onHide={handleModalClose}>
        <Modal.Header>
          <Modal.Title>{selectedPlace ? 'SOS markazini yangilash' : 'SOS markazi qo\'shish'}</Modal.Title>
          <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
            {LANGUAGES.map((lang) => (
                <li className="nav-item" key={lang.key}>
                  <button
                      className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                      onClick={() => setActiveTab(lang.key as lang)}
                  >
                    {lang.name}
                  </button>
                </li>
            ))}
          </ul>
        </Modal.Header>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <Form.Group controlId="formName">
              <Form.Label>Nomi</Form.Label>
              <Form.Control
                  type="text"
                  name={`name.${activeTab}`}
                  value={formik.values.name[activeTab]}
                  onChange={formik.handleChange}
                  required={!Boolean(selectedPlace)}
              />
            </Form.Group>
            <Form.Group controlId="formIsActive" className="mt-3">
              <Form.Label>Holati aktivmi?</Form.Label>
              <div className="form-check form-check-solid form-switch fv-row">
                <Form.Control
                    className="form-check-input w-45px h-30px"
                    type="checkbox"
                    name={"is_active"}
                    checked={formik.values.is_active}
                    onChange={formik.handleChange}
                />
                <label className="form-check-label"></label>
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Yopish
            </Button>
            <Button variant="primary" type="submit">
              {selectedPlace ? 'Yangilash' : 'Qo\'shish'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  );
};

export default SosModal;